import { createSlice } from "@reduxjs/toolkit";
import { GeozonesState } from "../entities/interfaces/geozones-state.interface";
import getGeozonesCases from "./cases/get-geozones.cases";

const initialState: GeozonesState = {
  geozones: [],
  isLoadingGeozones: false
};

const geozonesSlice = createSlice({
  name: "geozones/v2",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getGeozonesCases(builder);
  }
});

export default geozonesSlice.reducer;
